import store from '../user/store'

export default {
    user: {
        authenticated: false,
        profile: null
    },

    check() {
        if (localStorage.getItem("admin_api_token") === null) {
            this.user.authenticated = false
            this.user.profile = null

            return Promise.reject()
        } else {
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('admin_api_token')
            return axios.post('/admin/get-auth-user').then((res) => {
                // success
                window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('admin_api_token')
                this.user.authenticated = true
                this.user.profile = res.data.user

                // Auth Events ???

                return Promise.resolve(res)
            }).catch((err) => {
                // error
                this.user.authenticated = false
                this.user.profile = null

                return Promise.reject(err)
            })
        }

        // error
        this.user.authenticated = false
        this.user.profile = null

        return Promise.reject()
    },

    login(email, password, remember_me) {
        return axios.post('/admin/login', {
            email: email,
            password: password,
            remember_me: remember_me
        }).then((res) => {
            // success
            localStorage.setItem('admin_api_token', res.data.meta.token)
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('admin_api_token')

            return Promise.resolve(res)
        }).catch((err) => {
            // error
            return Promise.reject(err)
        })
    },

    ssoLogin(provider, response) {
        return axios
            .post(`/auth/${provider}/login`, response)
            .then(res => {
                localStorage.setItem('admin_api_token', res.data.meta.token)
                window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('admin_api_token')

                return Promise.resolve(res)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },

    logout() {
        return axios.post('/admin/logout').then((res) => {
            // success
            localStorage.removeItem('admin_api_token')
            window.axios.defaults.headers = null

            return Promise.resolve(res)
        }).catch((err) => {
            // error
            return Promise.reject(err)
        })
    },

    impersonate(user_id, is_reseller = false, reason = '') {
        return axios.post('/admin/user/impersonate', {
            user_id: user_id,
            is_reseller: is_reseller,
            reason: reason
        }).then((res) => {
            // Success - reseller admin account
            if (is_reseller) {
                localStorage.setItem('admin_api_token', res.data.meta.token)
                window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('admin_api_token')
            }

            // Success - standard user account
            if (!is_reseller) {
                localStorage.setItem('api_token', res.data.token)
                localStorage.setItem('current_user_id', res.data.user.id)
                localStorage.setItem('company_id', res.data.company.id)
                store.commit('cache/SET_CURRENT_COMPANY', res.data.company)
            }

            return Promise.resolve(res)
        }).catch((err) => {
            // error
            return Promise.reject(err)
        })
    },
}
